import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

export const GMAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const MAP_ID = "DEMO_MAP_ID";

export function GCircle({ center, radius, color, fillOpacity = 0.08, weight = 1.5, dashed = false }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google) return undefined;
    const c = new window.google.maps.Circle({
      map, center, radius, strokeColor: color, strokeOpacity: dashed ? 0.5 : 0.9, strokeWeight: weight,
      fillColor: color, fillOpacity, clickable: false,
    });
    return () => { c.setMap(null); };
  }, [map, center.lat, center.lng, radius, color, fillOpacity, weight, dashed]);
  return null;
}

export function FitPoints({ points, single = 10, maxZoom = 11 }) {
  const map = useMap();
  const sig = points.map((p) => `${p.lat},${p.lng}`).join("|");
  useEffect(() => {
    if (!map || !window.google || !points.length) return;
    if (points.length === 1) { map.setCenter(points[0]); map.setZoom(single); return; }
    const b = new window.google.maps.LatLngBounds();
    points.forEach((p) => b.extend(p));
    map.fitBounds(b, 40);
    window.google.maps.event.addListenerOnce(map, "idle", () => { if (map.getZoom() > maxZoom) map.setZoom(maxZoom); });
  }, [map, sig]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export const Dot = ({ color, size = 14, border = "#fff", label }) => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", transform: label ? "translateY(-4px)" : undefined }}>
    {label && <span style={{ background: "#fff", borderRadius: 6, padding: "2px 6px", fontSize: 11, fontWeight: 700, boxShadow: "0 1px 4px rgba(0,0,0,.25)", marginBottom: 3, whiteSpace: "nowrap" }}>{label}</span>}
    <span style={{ width: size, height: size, borderRadius: "50%", background: color, border: `2px solid ${border}`, boxShadow: "0 1px 4px rgba(0,0,0,.35)", display: "block" }} />
  </div>
);
